import ChangePassword from '@components/account-info/change-password';

const ChangePasswordPage = () => {
  return <ChangePassword />;
};

export default ChangePasswordPage;
